import { render, staticRenderFns } from "./Blox.vue?vue&type=template&id=66713354&"
import script from "./Blox.vue?vue&type=script&lang=js&"
export * from "./Blox.vue?vue&type=script&lang=js&"
import style0 from "./Blox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports